import * as React from 'react';
import { EntityType } from 'types/common';
import {
  AutocompletePicker,
  AutocompletePickerProps,
} from '../AutocompletePicker';
import { createFilterOptions } from '@material-ui/lab';

export interface BaseOptionsPickerProps<T extends EntityType>
  extends Omit<AutocompletePickerProps<T>, 'loadData'> {
  getOptions: (searchTerm: string | null) => T[];
}

export function BaseOptionsPicker<T extends EntityType>(
  props: BaseOptionsPickerProps<T>,
) {
  const { getOptions, ...other } = props;
  const loadData = async (searchTerm: string | null): Promise<T[]> =>
    new Promise<T[]>(resolve => {
      const opts = getOptions(searchTerm);
      resolve(opts);
    });
  return (
    <AutocompletePicker
      loadData={loadData}
      filterOptions={
        props.filterSelectedOptions === false
          ? undefined
          : createFilterOptions({
              ignoreAccents: true,
              ignoreCase: true,
              stringify: option => option.Name,
              trim: true,
            })
      }
      {...other}
    />
  );
}
